export const attributeInputMap = {
    freeform: 'text',
    choice: 'autocomplete',
};
